import { render, staticRenderFns } from "./StaffModified.vue?vue&type=template&id=be7a89f6&"
import script from "./StaffModified.vue?vue&type=script&lang=js&"
export * from "./StaffModified.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports